import React, {Component} from 'react';
import {Modal, Button, Row}  from 'react-bootstrap'
import SecondServer from '../../database/SecondServer'
import { siteAccessCode } from '../../database/apiv2SiteAccessor';


import '../report-header.css'

export default class DeviceDecommission extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      errMsg: null,
      changedInputs: [],
      dialogContent: 1,
      show: props.show ?? false
    }
    this.saved = false;
    this.handleClose = this.handleClose.bind(this);
    this.moveOn = this.moveOn.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.show !== this.props?.show) {
      this.defaultState();
      this.initStateFromProps();
    }
  }

  defaultState () {
    this.setState ({errMsg: null, changedInput: [], dialogContent: 1, show: this.props?.show})
  }

  async initStateFromProps () {
      this.saved = false;
  }
  
  async saveChanges() {
    const sitesURLPrefix = "/tehama/sites"
    const ac=siteAccessCode(this.props.getActiveSite());
    let url = sitesURLPrefix+'/devices/'+this.props.deviceId+'/target-ac?access_code='+ac
    const ss = new SecondServer(this.props);

    await ss.apiDeleteData (url);   //decommission
    if (ss.getErrorMsg()) this.setState ( {errMsg: ss.getErrorMsg() } );
   
    this.saved = true;
  }

  async handleClose() {
    this.setState ({show: false});
    const newState = {onOff: false, deviceId: null, refresh: this.saved}
    this.props.onHide(newState);
  }

 
  async moveOn (msg) {
    await this.saveChanges();
    this.handleClose();
  }

  renderHeader(title) {
    return (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )    
  }
  
renderTab1() {
    return(
      <Modal.Body className='body-indent'>
        <Row className='mt-5 modal-top-row '>
          Are you sure you want to decommission this device?
        </Row>
        <Row className='mt-5 modal-top-row '>
          Device {this.props.deviceId}
        </Row>

      </Modal.Body>
    )
  }

  render() {
    return(
      <Modal show={this.state.show} onHide={this.handleClose} size="lg" contentClassName="custom-modal">
        {this.renderHeader("Confirm Decommission Device")}
        {this.renderTab1()}
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" onClick={()=>this.handleClose()}>Cancel</Button>
          <Button className="custom-std-btn" onClick={()=>this.moveOn()}>Decommmission</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}  
